import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SnackService } from "app/shared/services/snack-service.service";
import { environment } from "environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { Meta } from "../models/meta.model";

@Injectable({
  providedIn: "root",
})
export class AdministrationService {
  private _meta$ = new BehaviorSubject<Meta>(null);

  get meta$(): Observable<Meta> {
    return this._meta$.asObservable();
  }

  constructor(
    private http: HttpClient,
    private snackService: SnackService,
  ) {}

  loadMeta(): void {
    this.http.get<Meta>(`${environment.api()}/meta`).subscribe((meta) => {
      this._meta$.next(meta);
    });
  }

  saveMeta(m: Meta): void {
    this.http.post<Meta>(`${environment.api()}/meta`, m).subscribe((meta) => {
      this._meta$.next(meta);
      this.snackService.success(`Informations enregistrées`);
    });
  }
}
